module.exports = __webpack_public_path__ + "img/spotify.cbc93c0e.svg";